export default dateTimestamp => new Date(dateTimestamp || Date.now()).setHours(0, 0, 0, 0)
